export default {
  get name(): string {
    return 'ExponentFacebook';
  },
};
